module.exports = __webpack_public_path__ + "img/SPACE.04eaa17c.png";